import React from "react";
import Topbar from "../../components/Topbar";
import Bottombar from "../../components/Bottombar";
import { ReactComponent as ContactIcon } from "../../assets/svgs/support.svg";
import Header from "../../components/Header";

function ContactPage() {
  return (
    <div className="dark:bg-black bg-white h-screen w-screen">
      <Topbar />
      <Header />
      <div className="flex flex-col mt-2 dark:bg-black bg-white">
        <div className="bg-[#fff] dark:bg-black overflow-x-hidden overflow-y-auto h-[85vh] w-full z-10">
          <div className="text-black dark:text-white font-sans font-bold text-[20px] sm:ml-[5rem] ml-3 mt-2">
            Contact Us
          </div>
          <div className="bg-white dark:bg-black h-full p-5">
            <div className="flex flex-col items-center gap-6">
              <ContactIcon className="h-12 w-12 text-black dark:text-white" />
              <div className="text-black dark:text-gray-400 font-sans text-[14px] text-center">
                <p>
                  <strong>Phone:</strong> +256-700787873, +256-777787873
                </p>
                <p>
                  <strong>Email:</strong>{" "}
                  <a
                    href="mailto:support@example.com"
                    className="text-blue-500"
                  >
                    support@example.com
                  </a>
                  ,{" "}
                  <a
                    href="mailto:helpdesk@example.com"
                    className="text-blue-500"
                  >
                    helpdesk@example.com
                  </a>
                </p>
                <p>
                  <strong>Office Address:</strong> 123, William Street, Kampala,
                  Uganda
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:hidden absolute bottom-0 z-40 w-full">
        <Bottombar activeBar="contact" />
      </div>
    </div>
  );
}

export default ContactPage;
